// extracted by mini-css-extract-plugin
export default {"Conteudo":"Conteudo_Conteudo__09rc4","card":"Conteudo_card__lFOjh","container":"Conteudo_container__Vgaxt"};